export const API_DTG_ROUTE = '/api/dtg';

export function buildApiDuplicateRoute(id: string): string {
    return `${API_DTG_ROUTE}/${id}/duplicate`;
}
